import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { Balcony, MonetizationOn, SquareFoot } from '@mui/icons-material';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	List,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import { OBJECTS_TYPES } from '../../../constants';
import { CommerceType } from '../../../types';

export const CommerceCard = ({ data }: { data: CommerceType }) => {
	const translate = useTranslate();
	const {
		name,
		area,
		id,
		rent_usd_object_price,
		sale_usd_object_price,
		facade
	} = data;

	return (
		<Card sx={{ maxWidth: 210, display: 'flex', flexDirection: 'column' }}>
			<CardMedia
				component="img"
				height="140"
				image="https://img.freepik.com/free-photo/modern-business-center_1127-3112.jpg?semt=ais_hybrid&w=740"
				alt="commerce_image"
			/>
			<CardContent
				sx={{
					padding: 1
				}}
			>
				<Typography noWrap variant="h6" component="div">
					{name}
				</Typography>
				<List>
					<ListItem disablePadding={true}>
						<SquareFoot />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`${area} м²`}
						/>
					</ListItem>
					<ListItem disablePadding={true}>
						<MonetizationOn />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`Продаж: ${sale_usd_object_price} $`}
						/>
					</ListItem>
					<ListItem disablePadding={true}>
						<MonetizationOn />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`Оренда: ${rent_usd_object_price} $`}
						/>
					</ListItem>
					<ListItem disablePadding={true}>
						<Balcony />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`Фасад: ${facade ? 'Так' : 'Ні'}`}
						/>
					</ListItem>
				</List>
			</CardContent>
			<CardActions
				sx={{
					marginTop: 'auto'
				}}
			>
				<Button
					component={Link}
					to={`/objects/${OBJECTS_TYPES.COMMERCES}/show/${id}`}
					size="small"
				>
					{translate('list.details')}
				</Button>
			</CardActions>
		</Card>
	);
};
